import React, { Component } from "react";
import { connect } from 'react-redux';
import { FormGroup, ControlLabel, FormControl, Label, Radio, Row, Col } from "react-bootstrap";

class HorizontalFormRadiobuttons extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange = event => {
    // this.setState({title: eventKey});
    this.props.onValueChange(event.target.value,this.props.statekey, this.props.eth);
  };
  render() {
    const {label, status, ncols, options, ...rest} = this.props;
    const {checked} = this.props;
    var row = [];

    for (var i = 0; i < ncols.length; i++) {
      row.push(
        <div key={i} className={ncols[i] + (checked? ' checked': ' unchecked')}>
          <Radio style={{display: "inline"}}
          onChange={this.onChange} {...rest}>{label}</Radio>
        </div>
      );
    }
    return row;
  }
}

export default HorizontalFormRadiobuttons;
